export const ERROR_MESSAGES = {
  EMPLOYEE_APPLY_LEAVE_FAILURE: "Unable to update your correction",
  EMPLOYEE_DASHBOARD_FETCH_FAILURE:
    "Failed to fetch employee dashboard details",
  FETCH_EMPLOYEE_DASHBOARD_POP_UP_FAILURE:
    "Failed to fetch dashboard pop up details",
  APPROVE_LEAVE_UPDATE_FAILURE: "Failed to process leave approval",
  EMPLOYEE_ATTENDANCE_CORRECTION_UPDATE_FAILURE:
    "Unable to update attendance correction",
  EMPLOYEE_RESET_PASSWORD_EMAIL_FAILURE: "Unable to sent reset password email",
  EMPLOYEE_CHANGE_PASSWORD_FAILURE: "Unable to change password",
  INITIATE_EXIT_FAILURE: "Failed to initiate exit process",
  FETCH_ASSIGNED_MANAGER_TO_EMPLOYEE_FAILURE:
    "Failed to fetch assigned manager",
  EMPLOYEES_LIST_FETCH_FAILURE: "Failed to fetch employees list",
  FETCH_SURVEY_FORMS_FAILURE: "Failed to fetch survey form list",
  FETCH_SURVEY_FORMS_INVITED_EMPLOYEES:
    "Failed to fetch assigned users to form",
  FETCH_ASSIGN_SURVEY_FORM_TO_EMPLOYEES:
    "Failed to assigned survey form to users",
  EDIT_DEPARTMENT_FAILURE: "Failed to get the department details",
  CHANGE_STATUS_SURVEY_QUESTION_FAILURE:
    "Failed to change status survey form related questions",
  UPDATE_SURVEY_FORM_STATUS_FAILURE: "Failed to change form status",
  FETCH_SURVEY_FORM_RESPONSE_FAILURE: "Failed to fetch survey form details",
  CREATE_SURVEY_FORM_FAILURE: "Failed to add new survey form",
  CREATE_DEPARTMENT_FAILURE: "Failed to add new department",
  SURVEY_FORM_QUESTION_ADD_FAILURE: "Failed to add new question in survey form",
  SURVEY_FORM_RESPONSE_SUBMIT_FAILURE: "Failed to submit survey form response",
  UPDATE_DEPARTMENT_FAILURE: "Failed to update the department",
  UPDATE_DEPARTMENT_STATUS_FAILURE: "Failed to update the department status",
  SURVEY_FORM_WITH_QUESTIONS_FAILURE: "Failed to form data with questions",
  UPLOAD_DAILY_REPORT_FAILURE: "Failed to update today daily report",
  TRAINING_VIDEOS_FETCH_FAILURE: "Failed to fetch training videos",
  TEAM_MEMBERS_LIST_FETCH_FAILURE: "Failed to fetch team members list",
  TEAM_MEMBERS_LEAVE_LIST_FETCH_FAILURE:
    "Failed to fetch team members' leave data",
  TEAM_MEMBERS_ATTENDANCE_LIST_FETCH_FAILURE:
    "Failed to fetch team member's attendance data",
  TEAM_MEMBERS_ATTENDANCE_APPROVE_UPDATE_FAILURE:
    "Failed to process attendance approval",
  TEAM_MEMBERS_DAILY_DAIRY_REPORT_FETCH_FAILURE:
    "Failed to process team members daily dairy report failure",
  TEAM_MEMBERS_CONVEYANCE_LIST: "Failed to fetch team members conveyance",
  MIS_DOWNLOAD_DETAILS_FETCH_FAILURE: "Failed to fetch Mis folder details",
  FETCH_EMPLOYEE_LEAVE_TYPES_FAILURE: "Failed to fetch leave types",
  FETCH_EMPLOYEE_LEAVE_LIST_FAILURE: " Failed to fetch to leave information",
  FETCH_EMPLOYEE_LEAVE_COMPOFF_FAILURE: "Failed to fetch Avaiable CompOffs",
  DAILY_REPORT_LIST_FETCH_FAILURE: "Failed to fetch daily report list",
  EDUCATION_LIST_FETCH_FAILURE: "Failed to fetch education list",
  DOWNLOAD_DAILY_REPORT_FAILURE: "Failed to download daily report file",
  DOCUMENT_TYPES_LIST_FAILURE: "Failed to fetch document types",
  FETCH_EMPLOYEE_CONVEYANCE_LIST_FAILURE:
    "Failed to fetch conveyance details list",
  EMPLOYEE_CONVEYANCE_ADD_FAILURE: "Failed to apply conveyance",
  CENTERS_LIST_FETCH_FAILURE: "Failed to fetch center list",
  DEPARTMENT_LIST_FETCH_FAILURE: "Failed to fetch department list",
  LIST_DESIGNATION_FAILURE: "Failed to fetch designation list",
  SUB_DEPARTMENT_LIST_FETCH_FAILURE: "Failed to fetch sub-department list",
  DEPARTMENT_WISE_TASKS_LIST_FETCH_FAILURE:
    "Failed to fetch department task wise list failure",
  DEPARTMENT_WISE_SUBCATEGORY_TASKS_LIST_FETCH_FAILURE:
    "Failed to fetch department sub cateogry task wise list failure",
  EMPLOYEE_ATTENDANCE_DETAILS_LIST_FAILURE:
    "Failed to fetch attendance details",
  EMPLOYEE_OFFICIAL_INFORMATION_UPDATE_FAILURE:
    "Failed to update official information",
  EMPLOYEE_PERSONAL_INFORMATION_UPDATE_FAILURE:
    "Failed to update personal information",
  EMPLOYEE_WORK_INFORMATION_UPDATE_FAILURE:
    "Failed to update work information details",
  EMPLOYEE_FINANCIAL_INFORMATION_UPDATE_FAILURE:
    "Failed to update financial information details",
  EMPLOYEE_FAMILY_INFORMATION_UPDATE_FAILURE:
    "Failed to update family information details",
  EMPLOYEE_EDUACTION_INFORMATION_UPDATE_FAILURE:
    "Failed to update education information details",
  EMPLOYEE_PROFILE_DETAILS_FETCH_FAILURE:
    "Failed to fetch employee profile details",
  EMPLOYEE_REIMBURSEMENT_ADD_FAILURE: "Failed to saved reimbursement form",
  FETCH_EMPLOYEE_REIMBURSEMENT_LIST_FAILURE:
    "Failed to fetch reimbursement list",
  FETCH_EMPLOYEE_REIMBURSEMENT_CATEGORY_LIST_FAILURE:
    "Failed to fetch reimbursement category list",
  IMBURSEMENT_BILL_VIEW_ERROR: "Failed to fetch reimbursement bill image",
  PETTY_CASH_EXPENSE_CATEGORIES_FAILURE:
    "Failed to fetch petty cash expense categories list",
  EMPLOYEE_PETTY_CASH_ADD_FAILURE: "Failed to submit petty cash expense form",
  EMPLOYEE_PETTY_CASH_EXPENSE_LIST_FAILURE:
    "Failed to fetch petty cash expense list",
  EMPLOYEE_PETTY_CASH_ACCOUNT_ZONE_DASHBOARD_FAILURE:
    "Failed to fetch petty cash account zone dashboard details",
  EMPLOYEE_PETTY_CASH_EXPENSE_DELETE_FAILURE:
    "Failed to remove petty cash expense",
  PETTY_CASH_ACCOUNT_ZONE_ADD_BALANCE_FAILURE: "Failed to add balance",
  UPDATE_EMPLOYEE_MANAGER_FAILURE: "Failed to update employee manager",
  UPDATE_EMPLOYEE_STATUS_FAILURE: "Failed to update employee status",
  EMPLOYEE_ATTENDANCE_PUNCH_FAILURE: "Unable to mark your attendance",
  UPDATE_EMPLOYEE_EDIT_OPTIONS_FAILURE: "Unable to update the edit options",
  EMPLOYEE_CALLING_SYSTEM_UPDATE_STATUS_FAILURE:
    "Unable to update user calling system status",
  UPDATE_BULK_ATTENDANCE_APPROVED_FAILURE:
    "Unable to update bulk attendance approved failure",
  UPDATE_BULK_LEAVE_APPROVED_FAILURE:
    "Unable to update bulk leave approved failure",
  UPDATE_EMPLOYEE_PROBATION_FAILURE: "Failed to update employee probation",
  EMPLOYEE_CONVEYANCE_DELETE_FAILURE: "Unable to delete the conveyance",
  EMPLOYEE_REIMBURSEMENT_DELETE_FAILURE: "Unable to delete the reimbursement",
  FETCH_HR_EMPLOYEE_MASTER_DATA_FAILURE: "Unable to fetche employee details",
  FETCH_EMPLOYEE_SALARY_REPORT_FAILURE:
    "Unable to fetch employee salary report",
  EXPORT_FETCH_HR_EMPLOYEE_MASTER_DATA_FAILURE:
    "Unable to fetche employee details",
  EXPORT_REIMBRUSEMENT_REPORT_FAILURE: "Unable to fetch reimbursement report",
  FETCH_REIMBURSEMENT_REPORT_FAILURE: "Unable to fetch reimburesment report",
  FETCH_CONVEYANCE_REPORT_FAILRURE: "Unable to fetch conveyance report",
  FETCH_EMPLOYEE_LEAVE_REPORT_FAILURE: "Unable to fetch leave report",
  FETCH_EMPLOYEE_PROBATION_LIST_FAILURE:
    "Unable to fetch employee probation list",
  FETCH_EMPLOYEE_MONTHLY_WISE_LIST_FAILURE:
    "Unable to fetch employee monthly wise report list",
  HR_MARK_EMPLOYEE_BULK_ATTENDANCE_CORRECTION_FAILURE:
    "Unable to update the employee bulk attendance correction",
  EXPORT_BULK_EMPLOYEE_ATTENDANCE_REPORT_FAILURE:
    "Unable to export bulk employee attendance report",
  CREATE_DEPARTMENT_CATEGORY_FAILURE: "Unable to add department task.",
  DELET_DEPARTMENT_CATEGORY_FAILURE: "Unable to delete department task.",
  CLOSE_DAILY_DAIRY_FAILURE: "Unable to close today dairy",
  SUBMIT_DAILY_DAIRY_FAILURE: "Unable to submit today dairy",
  FETCH_DAILY_DAIRY_SLOTS_FAILURE: "Unable to fetch daily dairy slots",
  FETCH_LOGIN_DETAILS_FAILURE: "Failed to fetch login details",
  FAILED_EMPLOYEE_UPDATE_PROFILE_PIC:
    "Failed to udpate the employee profile pic",
  EDIT_DESIGNATION_FAILURE: "Failed to edit designation",
  SAVE_UPDATE_DESIGNATION_FAILURE: "Failed to update save designation",
  EDIT_SECTION_FAILURE: "Failed to update edit section",
  EDIT_SURVEY_FORM_FAILURE: "Failed to edit survey form",
  SAVE_UPDATE_SECTION_FAILURE: "Failed to save/update section",
  SAVE_UPDATE_SURVEY_FORM_FAILURE: "Failed to save survey form",
  LIST_SECTION_FAILURE: "Failed to fetch sections",
  GET_FORM_RESPONSES_FAILURE: "Failed to fetch user's form responses details",
  FETCH_USER_TYPE_LIST_FAILURE: "Failed to fetch user type list list",
  SEND_PROBATION_REMINDER_MAIL_FAILURE:
    "Failed to send probation remainder mail failure",
  FETCH_EMPLOYEES_TYPES_FAILURE: "Failed to fetch employee types",
  FETCH_INVENTORY_CATEGORY_FAILURE: "Failed to fetch inventory's category list",
  SAVE_UPDATE_INVENTORY_CATEGORY_FAILURE: "Failed to save inventory category",
  EDIT_INVENTORY_CATEGORY_FAILURE: "Failed to edit inventory category",
  FETCH_INVENTORY_VENDOR_FAILURE: "Failed to fetch inventory's vendor list",
  SAVE_UPDATE_INVENTORY_VENDOR_FAILURE: "Failed to save vendor details",
  EDIT_INVENTORY_VENDOR_FAILURE: "Failed to edit vendor details",
  FETCH_INVENTORY_PRODUCT_FAILURE: "Failed to fetch inventory's products list",
  SAVE_INVENTORY_PRODUCT_FAILURE: "Failed to save inventory product",
  EDIT_INVENTORY_PRODUCT_FAILURE: "Failed to edit inventory product",
  UPDATE_INVENTORY_PRODUCT_FAILURE: "Failed to update inventory product",
  SAVE_INVENTORY_ACTION_FAILURE: "Failed to save inventory action",
  FETCH_EMPLOYEE_INVENTORY_PRODUCT_FAILURE: "Failed to fetch employee inventory product list",
  FETCH_INVENTORY_PRODUCT_LOGS_FAILURE: "Failed to fetch inventory's products logs list",
  SEND_INVENTORY_ACTION_OTP_FAILURE: "Failed to send inventory action otp",
  FETCH_INVENTORY_BRAND_FAILURE: "Failed to fetch brand list",
};
